import { Logo } from './Logo';
import { MarketplaceSelector } from './MarketplaceSelector';
import { UserInfo } from './UserInfo';
import styles from './Header.module.css';

const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.logoSection}>
          <Logo />
        </div>
        <div className={styles.rightSection}>
          <MarketplaceSelector />
          <UserInfo />
        </div>
      </div>
    </header>
  );
};

export { Header };
